import {
  ISchoolShiftProps,
  ISchoolShiftSimpleProps,
  ISchoolShiftCreateParams,
  ISchoolShiftUpdateParams,
} from './types';
import { api } from '../DefaultService';

const ENDPOINT = 'v1/schoolshift';

export const createSchoolShiftAsync = async ({
  data,
}: ISchoolShiftCreateParams): Promise<ISchoolShiftProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSchoolShiftByIdAsync = async (
  id: number,
): Promise<ISchoolShiftProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSchoolShiftByLicenseAsync = async (): Promise<
  ISchoolShiftSimpleProps[]
> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSchoolShiftAsync = async ({
  id,
  data,
}: ISchoolShiftUpdateParams): Promise<ISchoolShiftProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSchoolShiftAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
